import { useContext } from 'react';
import TourContext from '../contexts/TourContext';
import { jsx as _jsx } from "react/jsx-runtime";
const UITourWatcher = () => {
  const {
    tour
  } = useContext(TourContext);
  const tourId = tour && tour.getTour();
  // TODO: Add detecting communication mechanism

  if (!tourId) {
    return null;
  }
  return /*#__PURE__*/_jsx("template", {
    "data-tour-id": tourId || ''
  });
};
export default UITourWatcher;